import { Text } from 'rebass';

const capitalize = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

const Code = ({ backgroundColor, ...props }) => {
  return (
    <Text
      as="code"
      css={`
        font-family: 'Roboto Mono', monospace;
        font-size: 14px;
        background: var(--background${capitalize(backgroundColor)}Muted);
        color: ${backgroundColor === 'gray' ? 'var(--textNeutral)' : `var(--text${capitalize(backgroundColor)})`};
        padding: 1px 4px;
        border-radius: 4px;
        margin-right: 4px;
      `}
      {...props}
    />
  )
}

Code.defaultProps = {
  backgroundColor: 'gray',
}

export default Code;